import React from 'react';

import PGCredentialsForm from './components/PGCredentialsForm';
import PGCredentialsModeForm from './components/PGCredentialsModeForm';
import PGCredentialsPricingForm from './components/PGCredentialsPricingForm';
import { getTimelineStatus } from 'utils/helperMethods';
import { toast } from 'react-toastify';
import { capitalize } from 'lodash';
import view_icon from "../../static/images/View.png";
import hide_icon from "../../static/images/hide.png";

export const PAYMENT_GATEWAY_ENUM = {
    PAYU: 'payu',
    CYBS: 'cybs',
    MIGS: 'migs',
    CCA: 'cca',
    HDFC: 'hdfc',
    BDK: 'bdk',
    FISERV: 'fiserv',
    MPGS: 'mpgs',
};

export const PAYMENT_GATEWAY_OPTION = [
    { value: PAYMENT_GATEWAY_ENUM.PAYU, name: 'PayU' },
    { value: PAYMENT_GATEWAY_ENUM.CYBS, name: 'CyberSource' },
    { value: PAYMENT_GATEWAY_ENUM.MIGS, name: 'MIGS' },
    { value: PAYMENT_GATEWAY_ENUM.CCA, name: 'ccavenue' },
    { value: PAYMENT_GATEWAY_ENUM.HDFC, name: 'HDFC' },
    { value: PAYMENT_GATEWAY_ENUM.BDK, name: 'BDK' },
    { value: PAYMENT_GATEWAY_ENUM.FISERV, name: 'Fiserv' },
    { value: PAYMENT_GATEWAY_ENUM.MPGS, name: 'MPGS' },
];

export const PAYMENT_GATEWAY_CREDENTIALS_FIELD_MAP = {
    [PAYMENT_GATEWAY_ENUM.CCA]: [
        {
            fieldType: 'input',
            label: 'Merchant PG Key',
            name: 'merchantPGKey',
            props: {
                placeholder: 'Enter PG Key',
                type: 'password',
                showPasswordIconUrl: view_icon,
                hidePasswordIconUrl: hide_icon,
            },
        },
        {
            fieldType: 'input',
            label: 'Security Key',
            name: 'merchantPGSecurityKey',
            props: {
                placeholder: 'Enter Security Key',
                type: 'password',
                showPasswordIconUrl: view_icon,
                hidePasswordIconUrl: hide_icon,
            },
        },
    ],
    [PAYMENT_GATEWAY_ENUM.CYBS]: [
        {
            fieldType: 'input',
            label: 'Username',
            name: 'username',
            props: {
                placeholder: 'Enter Username',
                type: 'text',
            },
        },
        {
            fieldType: 'input',
            label: 'SOAP Key',
            name: 'soapKey',
            props: {
                placeholder: 'Enter SOAP',
                type: 'password',
                showPasswordIconUrl: view_icon,
                hidePasswordIconUrl: hide_icon,
            },
        },
        {
            fieldType: 'input',
            label: 'Security Key',
            name: 'merchantPGSecurityKey',
            props: {
                placeholder: 'Enter Security Key',
                type: 'password',
                showPasswordIconUrl: view_icon,
                hidePasswordIconUrl: hide_icon,
            },
        },
        {
            fieldType: 'input',
            label: 'Merchant PG Key',
            name: 'merchantPGKey',
            props: {
                placeholder: 'Enter PG Key',
                type: 'password',
                showPasswordIconUrl: view_icon,
                hidePasswordIconUrl: hide_icon,
            },
        },
    ],
    [PAYMENT_GATEWAY_ENUM.MIGS]: [
        {
            fieldType: 'input',
            label: 'Security Key',
            name: 'merchantPGSecurityKey',
            props: {
                placeholder: 'Enter Security Key',
                type: 'password',
                showPasswordIconUrl: view_icon,
                hidePasswordIconUrl: hide_icon,
            },
        },
        {
            fieldType: 'input',
            label: 'Merchant PG Key',
            name: 'merchantPGKey',
            props: {
                placeholder: 'Enter PG Key',
                type: 'password',
                showPasswordIconUrl: view_icon,
                hidePasswordIconUrl: hide_icon,
            },
        },
        {
            fieldType: 'input',
            label: 'Username',
            name: 'username',
            props: {
                placeholder: 'Enter Username',
                type: 'text',
            },
        },
        {
            fieldType: 'input',
            label: 'Password',
            name: 'password',
            props: {
                placeholder: 'Enter Password',
                type: 'password',
                showPasswordIconUrl: view_icon,
                hidePasswordIconUrl: hide_icon
            },
        },
    ],
    [PAYMENT_GATEWAY_ENUM.PAYU]: [
        {
            fieldType: 'input',
            label: 'Merchant PG Key',
            name: 'merchantPGKey',
            props: {
                placeholder: 'Enter PG Key',
                type: 'password',
                showPasswordIconUrl: view_icon,
                hidePasswordIconUrl: hide_icon,
            },
        },
    ],
    [PAYMENT_GATEWAY_ENUM.HDFC]: [
        {
            fieldType: 'input',
            label: 'Merchant PG Key',
            name: 'merchantPGKey',
            props: {
                placeholder: 'Enter PG Key',
                type: 'password',
                showPasswordIconUrl: view_icon,
                hidePasswordIconUrl: hide_icon,
            },
        },
        {
            fieldType: 'input',
            label: 'Encryption Key',
            name: 'encryptionKey',
            props: {
                placeholder: 'Enter Encryption Key',
                type: 'password',
                showPasswordIconUrl: view_icon,
                hidePasswordIconUrl: hide_icon,
            },
        },
    ],
    [PAYMENT_GATEWAY_ENUM.BDK]: [
        {
            fieldType: 'input',
            label: 'Security Key',
            name: 'merchantPGSecurityKey',
            props: {
                placeholder: 'Enter Security Key',
                type: 'password',
                showPasswordIconUrl: view_icon,
                hidePasswordIconUrl: hide_icon,
            },
        },
        {
            fieldType: 'input',
            label: 'Merchant PG Key',
            name: 'merchantPGKey',
            props: {
                placeholder: 'Enter PG Key',
                type: 'password',
                showPasswordIconUrl: view_icon,
                hidePasswordIconUrl: hide_icon,
            },
        },
    ],
    [PAYMENT_GATEWAY_ENUM.FISERV]: [
        {
            fieldType: 'input',
            label: 'Security Key',
            name: 'merchantPGSecurityKey',
            props: {
                placeholder: 'Enter Merchant Security Key',
                type: 'password',
                showPasswordIconUrl: view_icon,
                hidePasswordIconUrl: hide_icon
            },
        },
        {
            fieldType: 'input',
            label: 'Merchant PG Key',
            name: 'merchantPGKey',
            props: {
                placeholder: 'Enter Merchant PG Key',
                type: 'password',
                showPasswordIconUrl: view_icon,
                hidePasswordIconUrl: hide_icon,
            },
        },
    ],
    [PAYMENT_GATEWAY_ENUM.MPGS]: [
        {
            fieldType: 'input',
            label: 'Security Key',
            name: 'merchantPGSecurityKey',
            props: {
                placeholder: 'Enter Merchant Security Key',
                type: 'password',
                showPasswordIconUrl: view_icon,
                hidePasswordIconUrl: hide_icon
            },
        },
        {
            fieldType: 'input',
            label: 'Merchant PG Key',
            name: 'merchantPGKey',
            props: {
                placeholder: 'Enter Merchant PG Key',
                type: 'password',
                showPasswordIconUrl: view_icon,
                hidePasswordIconUrl: hide_icon,
            },
        },
    ],
};

export const SECTION_TYPE_TO_URL_MAP = {
    credentialSection: 'mid',
    paymodeSection: 'payMode',
    pricingSection: 'feeConfig',
};

const baseUrl = '/payment-gateway-credentials/create/';
const baseUrlEdit = '/payment-gateway-credentials/edit/';
const baseUrlView = '/payment-gateway-credentials/view/';

export const onboardingProcessPG = (draftData, routePath) => {

    // console.log("ok here is draft data", draftData);
    const PAYMENT_GATEWAY_CREDENTIALS_TIMELINE_STEPS = [
        {
            component(props) {
                // eslint-disable-next-line react/prop-types
                const { draftData } = props;
                return (
                    <PGCredentialsForm
                        {...props} // eslint-disable-next-line react/prop-types
                        initialValues={(draftData && draftData.data) || {}}
                    />
                );
            },
            name: 'Credentials',
            sectionType: 'credentialSection',
            nextPath: `${baseUrl}pay-mode`,
            path: `${baseUrl}credentials`,
            previousPath: '/payment-gateway-credentials',
            isEditableComp: false,
            status: getTimelineStatus(
                draftData,
                routePath,
                'credentialSection',
                `${baseUrl}credentials`
            ),
            tabId: 1,
        },
        {
            component(props) {
                // eslint-disable-next-line react/prop-types
                const { draftData } = props;

                return (
                    <PGCredentialsModeForm
                        {...props} // eslint-disable-next-line react/prop-types
                        initialValues={(draftData && draftData.data) || {}}
                    />
                );
            },
            name: 'Payment Mode',
            sectionType: 'paymodeSection',
            nextPath: `${baseUrl}pricing`,
            isEditableComp: false,
            path: `${baseUrl}pay-mode`,
            previousPath: `${baseUrl}credentials`,
            status: getTimelineStatus(
                draftData,
                routePath,
                'paymodeSection',
                `${baseUrl}pay-mode`
            ),
            tabId: 2,
        },
        {
            component(props) {
                // eslint-disable-next-line react/prop-types
                // for creating a PG Credentials
                const { draftData } = props;
                // console.log("inside constants", draftData);
                let feeConfigListData = {};

                if (draftData?.data?.feeConfigList) {
                    Object.keys(draftData?.data?.feeConfigList).map(item => {
                        if (!draftData?.data?.feeConfigList?.[item]?.length) {
                            feeConfigListData[item] = [
                                draftData?.data?.feeConfigList[item],
                            ];
                        } else {
                            feeConfigListData[item] = draftData?.data?.feeConfigList[item];
                        }
                    });
                }

                return (
                    <PGCredentialsPricingForm
                        {...props}
                        initialValues={feeConfigListData || {}}
                        feeConfigList={feeConfigListData}
                    />
                );
            },
            name: 'Pricing',
            sectionType: 'pricingSection',
            nextPath: null,
            isEditableComp: false,
            path: `${baseUrl}pricing`,
            previousPath: `${baseUrl}pay-mode`,
            status: getTimelineStatus(
                draftData,
                routePath,
                'pricingSection',
                `${baseUrl}pricing`
            ),
            tabId: 3,
        },
    ];
    return PAYMENT_GATEWAY_CREDENTIALS_TIMELINE_STEPS;
};

export const onboardingProcessPGEdit = (isViewMode, credentialId, draftData) => {
    const PAYMENT_GATEWAY_CREDENTIALS_TIMELINE_STEPS = [
        {
            component(props) {
                // eslint-disable-next-line react/prop-types
                const { draftData } = props;
                return (
                    <PGCredentialsForm
                        {...props} // eslint-disable-next-line react/prop-types
                        initialValues={(draftData && draftData.data) || {}}
                    />
                );
            },
            name: 'Credentials',
            isViewMode: isViewMode,
            sectionType: 'credentialSection',
            isEditableComp: true,
            previousPath: '/payment-gateway-credentials',
            path: `${isViewMode ? baseUrlView : baseUrlEdit
                }credentials/${credentialId}`,
            nextPath: `${isViewMode ? baseUrlView : baseUrlEdit
                }pay-mode/${credentialId}`,
            status: (draftData.length) ? 'Complete' : 'Pending',
            tabId: 1
        },
        {
            component(props) {
                // eslint-disable-next-line react/prop-types
                const { draftData } = props;

                return (
                    <PGCredentialsModeForm
                        {...props} // eslint-disable-next-line react/prop-types
                        initialValues={(draftData && draftData.data) || {}}
                    />
                );
            },
            name: 'Payment Mode',
            sectionType: 'paymodeSection',
            isEditableComp: true,
            isViewMode: isViewMode,
            previousPath: `${isViewMode ? baseUrlView : baseUrlEdit
                }credentials/${credentialId}`,
            path: `${isViewMode ? baseUrlView : baseUrlEdit
                }pay-mode/${credentialId}`,
            nextPath: `${isViewMode ? baseUrlView : baseUrlEdit
                }pricing/${credentialId}`,
            status: (draftData.length > 1) ? 'Complete' : 'Pending',
            tabId: 2,
        },
        {
            component(props) {
                // eslint-disable-next-line react/prop-types
                // for editing the PG categories
                const { draftData } = props;
                let feeConfigListData = {};

                console.log(draftData, "DRAFT DATA --")

                if (draftData?.data?.feeConfigList) {
                    Object.keys(draftData?.data?.feeConfigList).map(item => {
                        if (!draftData?.data?.feeConfigList?.[item]?.length) {
                            feeConfigListData[item] = [
                                draftData?.data?.feeConfigList[item],
                            ];
                        } else {
                            feeConfigListData[item] = draftData?.data?.feeConfigList[item];
                        }
                    });
                }

                return (
                    <PGCredentialsPricingForm
                        {...props} // eslint-disable-next-line react/prop-types
                        initialValues={feeConfigListData || {}}
                        feeConfigList={feeConfigListData}
                    />
                );
            },
            name: 'Pricing',
            sectionType: 'pricingSection',
            isEditableComp: true,
            previousPath: `${isViewMode ? baseUrlView : baseUrlEdit
                }pay-mode/${credentialId}`,
            path: `${isViewMode ? baseUrlView : baseUrlEdit
                }pricing/${credentialId}`,
            nextPath: null,
            status: (draftData.length > 2) ? 'Complete' : 'Pending',
            tabId: 3,
        },
    ];
    return PAYMENT_GATEWAY_CREDENTIALS_TIMELINE_STEPS;
};

export const getPGCredentialPayModeRequestFromValues = ({
    values,
    DEBIT_CARD_OPTIONS,
    CREDIT_CARD_OPTIONS,
    UPI_OPTIONS,
    UPI_MANDATE_OPTIONS,
    NET_BANKING_OPTIONS,
    WALLET_OPTIONS,
    isEditMode,
}) => {
    const selectedCreditCards = values.creditCard || [];
    const selectedDebitCards = values.debitCard || [];
    const selectedNetBanking = values.netbanking || [];
    const selectedUPIOptions = values.upi;
    const selectedMandateUpi = values.mandateUpi || [];
    const selectedWalletList = values.wallets || [];
    if (
        values.upi &&
        values.upi.length > 0 &&
        values.upiBusinessSource &&
        values.upiBusinessSource.length <= 0
    ) {
        toast.error('Please select at least one UPI Business Source');
        return;
    }
    if (
        values.upi &&
        values.upi.length > 0 &&
        values.upiBusinessSource &&
        values.upiBusinessSource.length > 0
    ) {
        let isValidAccountType = true;
        let emptyBusinessSource = '';
        values.upiBusinessSource.forEach(
            (businessSource, businessSourceIndex) => {
                if (
                    !values[`upiAccountTypes-${businessSource}`] ||
                    values[`upiAccountTypes-${businessSource}`].length <= 0
                ) {
                    isValidAccountType = false;
                    emptyBusinessSource = businessSource;
                }
            }
        );
        if (isValidAccountType === false) {
            toast.error(
                `Please select at least one account type for ${capitalize(
                    emptyBusinessSource
                )} sources`
            );
            return;
        }
    }
    const creditCardOptions = CREDIT_CARD_OPTIONS.filter(mode =>
        selectedCreditCards.includes(mode.subMode)
    ).map(mode => ({
        paymentType: mode.paymentType,
        paymentModeInfo: mode.subMode,
        txnConfig: values.creditCardBusinessSource?.map(businessSource => {
            return { businessSource };
        }),
    }));

    // const upiOptions = UPI_OPTIONS?.filter(mode =>
    //     selectedUPIOptions?.includes(mode.subMode)
    // )?.map(mode => ({
    //     paymentType: mode.paymentType,
    //     paymentModeInfo: mode.subMode,
    //     paymentSubModeInfo: values.vpa,
    //     txnConfig: values.upiBusinessSource?.map(businessSource => {
    //         return {
    //             businessSource,
    //             accountType: values[`upiAccountTypes-${businessSource}`],
    //         };
    //     }),
    // }));
    // const mandateUPIOptions = UPI_MANDATE_OPTIONS.filter(
    //     mode =>
    //         selectedMandateUpi.includes(mode.subMode) &&
    //         selectedUPIOptions.includes(mode.subMode)
    // ).map(mode => ({
    //     paymentType: mode.paymentType,
    //     paymentModeInfo: mode.subMode,
    //     category: 'MANDATE',
    //     paymentSubModeInfo: values.vpa,
    //     txnConfig: values.upiBusinessSource?.map(businessSource => {
    //         return {
    //             businessSource,
    //             accountType: values[`upiAccountTypes-${businessSource}`],
    //         };
    //     }),
    // }));
    const debitCardOptions = DEBIT_CARD_OPTIONS.filter(mode =>
        selectedDebitCards.includes(mode.subMode)
    ).map(mode => ({
        paymentType: mode.paymentType,
        paymentModeInfo: mode.subMode,
        txnConfig: values.debitCardBusinessSource?.map(businessSource => {
            return { businessSource };
        }),
    }));
    const netBankingOptions = NET_BANKING_OPTIONS.filter(mode =>
        selectedNetBanking.includes(mode.subMode)
    ).map(mode => ({
        paymentType: mode.paymentType,
        paymentModeInfo: mode.subMode,
        issuerId : mode.subMode,
        txnConfig: [
            {
                businessSource: 'DOMESTIC',
            },
        ],
    }));
    const walletsOptions = WALLET_OPTIONS.filter(mode =>
        selectedWalletList.includes(mode.subMode)
    ).map(mode => ({
        paymentType: mode.paymentType,
        paymentModeInfo: mode.subMode,
        txnConfig: [
            {
                businessSource: 'DOMESTIC',
            },
        ],
    }));
    let request;
    if (isEditMode) {
        request = {
            paymentModeDetails: [
                ...creditCardOptions,
                ...debitCardOptions,
                ...netBankingOptions,
                ...walletsOptions
                // ...upiOptions,
                // ...mandateUPIOptions,
            ],
        };
    } else {
        request = {
            paymentModeSection: {
                paymentModeDetails: [
                    ...creditCardOptions,
                    ...debitCardOptions,
                    ...netBankingOptions,
                    ...walletsOptions
                    // ...upiOptions,
                    // ...mandateUPIOptions,
                ],
            },
        };
    }
    return request;
};

export const getSlabDataWithDetails = (modeDetails, basicDetails) => {
    // console.log("detail .......,,,,,,", modeDetails, basicDetails);
    const defaultVals = {
        transactionType: 'PAY',
    };
    let isDomestic = modeDetails.isDomestic ? 1 : 0;
    return basicDetails.filter(item => {
        // console.log("modeDetails.paymentType...", item.domesticFlag, item.paymentType, isDomestic, modeDetails.paymentType)
        return modeDetails.paymentType === item.paymentType &&
        isDomestic == item.domesticFlag
    }).map(item => ({...item, ...defaultVals}));
}

export const getSlabData = (modeDetails, isSingle) => {
    // console.log("modeDetails....", modeDetails, isSingle);
    if (isSingle) {
        return [
            {
                feePercent: 0,
                feeFlat: 0,
                feeCriteria: 'MAXIMUM',
                tax: 18,
                currency: 'INR',
                lowerSlab: '0.0',
                higherSlab: null,
                paymentType: modeDetails.paymentType,
                category: null,
                feeType: 'MDR',    // now this Feetype will populate in slabs 
                feeEntityId: null,
                cardType: 'all',
                domesticFlag: 0, // this should change in case of NB
                onUsFlag: false,
                accountType: null,
                entityType: 'AGGREGATOR',
                transactionType: 'PAY',
                type: 'MDR',    //previously this type populate in case of pgmid creation
            },
        ];
    } else {
        return [
            {
                feePercent: 0,
                feeFlat: 0,
                feeCriteria: 'MAXIMUM',
                tax: 18,
                currency: 'INR',
                lowerSlab: '0.0',
                higherSlab: '2000.0',
                entityType: 'AGGREGATOR',
                paymentType: modeDetails.paymentType,
                category: null,
                feeType: 0,
                feeEntityId: null,
                cardType: 'all',
                domesticFlag: (modeDetails?.[0]?.isDomestic || modeDetails.isDomestic) ? 1 : 0,
                onUsFlag: false,
                accountType: null,
                transactionType: 'PAY',
                type: 'MDR',
            },
            {
                feePercent: 0,
                feeFlat: 0,
                feeCriteria: 'MAXIMUM',
                tax: 18,
                currency: 'INR',
                lowerSlab: '2000.0',
                higherSlab: null,
                entityType: 'AGGREGATOR',
                paymentType: modeDetails.paymentType,
                category: null,
                feeType: 0,
                feeEntityId: null,
                cardType: 'all',
                domesticFlag: (modeDetails?.[0]?.isDomestic || modeDetails.isDomestic) ? 1 : 0,
                onUsFlag: false,
                transactionType: 'PAY',
                type: 'MDR',
            },
        ];
    }
};

// export const getPGCredentialPricingRequestFromValues = ({ values ,NET_BANKING_OPTIONS, isEditMode}) => {
//     let feeConfigList = [];
//     const NETBANKINGSECTION = 'Net-Banking';
//     console.log("values net banking", values);
//     const selectedNetBanking = values[NETBANKINGSECTION] || [];
//     console.log("select net banking", selectedNetBanking);
//     delete values.feeConfigList;
//     const sections = Object.keys(values);
//     let netBankingOptions = {};

//     netBankingOptions = NET_BANKING_OPTIONS.map(mode => {
//         // console.log("mode", mode);
//         selectedNetBanking.map(item => {
//             console.log("mode", mode);
//             console.log("item card type", item.cardType);
//             if (item?.cardType?.includes(mode?.name)) {
//                 netBankingOptions[item.cardType] = mode.subMode;
//             }
//         })
//     }
//     );
//     sections.forEach(section => {
//         let sectionData = values[section];
//         if (section === NETBANKINGSECTION) {

//         }
//         sectionData.forEach(feeCategoryInfo => {
//             console.log("feeCategory", feeCategoryInfo);

//             feeCategoryInfo.bankSlabs.forEach(bankSlab => {
//                 const updatedBankSlab = { ...bankSlab };
//                 console.log("updatedBankSlab", updatedBankSlab);
//                 const feeType = updatedBankSlab.feeType;
//                 updatedBankSlab.issuer =feeCategoryInfo.issuerId === 'all'? null: feeCategoryInfo.issuerId;
//                 if (feeCategoryInfo.cardType && netBankingOptions[feeCategoryInfo.cardType]) {
//                     updatedBankSlab.issuer = netBankingOptions[feeCategoryInfo.cardType];
//                 }
//                 updatedBankSlab.feeType = 1;
//                 updatedBankSlab.cardType =
//                     updatedBankSlab.cardType === 'all'
//                         ? null
//                         : updatedBankSlab.cardType;
//                 updatedBankSlab.slabs = [
//                     {
//                         lowerSlab: updatedBankSlab.lowerSlab,
//                         upperSlab: updatedBankSlab.higherSlab,
//                     },
//                 ];
//                 delete updatedBankSlab.higherSlab;
//                 delete updatedBankSlab.lowerSlab;
//                 delete updatedBankSlab.issuerId;
//                 const updatedField = {
//                     feeType: feeType,
//                     paymentOption: updatedBankSlab,
//                 };
//                 feeConfigList = [...feeConfigList, updatedField];
//             });
//         });
//     });
//     console.log("is edit mode", isEditMode, netBankingOptions, feeConfigList)
//     let request;
//     if (isEditMode) {
//         request = {
//             feeConfigList: [
//                 ...netBankingOptions,
//                 ...feeConfigList,
//             ],
//         };
//     } else {
//         request = {
//             feeConfigList: {
//                 feeConfigList: [
//                     ...netBankingOptions,
//                     ...feeConfigList,
//                 ],
//             },
//         };
//     }
//     return request;
// };


export const getPGCredentialPricingRequestFromValues = ({ values, NET_BANKING_OPTIONS, isEditMode }) => {
    let feeConfigList = [];
    const NETBANKINGSECTION = 'Net-Banking';
    const WALLETSECTION = 'Wallets';
    console.log("values net banking", values);
    const selectedNetBanking = values[NETBANKINGSECTION] || [];
    // console.log("select net banking", selectedNetBanking);
    delete values.feeConfigList;
    const sections = Object.keys(values);
    let netBankingOptions = {};

    // Creste a map of net banking options (name, subMode)
    const netBankingMap = {};

    NET_BANKING_OPTIONS.map(mode => {
        // console.log("mode", mode);

        selectedNetBanking.map(item => {

            // console.log("mode", mode);
            // console.log("item card type", item.cardType);
            if (item?.cardType?.includes(mode?.name)) {
                const type= mode.paymentType;
                // console.log("type", type);
                netBankingMap[item.cardType] = mode.subMode;
            }
        });
    });
    console.log("netbanking option map", netBankingOptions);

    sections.forEach(section => {
        let sectionData = values[section];

        (sectionData ?? []).forEach(feeCategoryInfo => {
            // console.log("feeCategory", feeCategoryInfo);
            let cardType = feeCategoryInfo.cardType;
            (feeCategoryInfo?.bankSlabs ?? []).forEach(bankSlab => {
                const updatedBankSlab = { ...bankSlab };
                // console.log("updatedBankSlab", updatedBankSlab);
                updatedBankSlab.feeType = 0;
                const feeType = updatedBankSlab.feeType;
                updatedBankSlab.feeEntityType = 'PG';
                // updatedBankSlab.issuer = feeCategoryInfo.issuerId === 'all' ? null : feeCategoryInfo.issuerId;
                // console.log("feecategoryinfo", feeCategoryInfo);
                // console.log("selectedNetbanking", selectedNetBanking);


                // if (section === NETBANKINGSECTION && feeCategoryInfo.cardType && netBankingMap[feeCategoryInfo.cardType]) {
                //     console.log("feeCategory card type", feeCategoryInfo.cardType);
                //     console.log("selected NetBaning ",selectedNetBanking[1].cardType);
                //     // console.log("netBanking map mode", netBankingMap[cardType]);
                //     updatedBankSlab.issuer = netBankingMap[feeCategoryInfo.cardType];
                //     updatedBankSlab.paymentType = NET_BANKING_OPTIONS.find(mode => feeCategoryInfo.cardType.includes(mode.name))?.paymentType || null;
                //     console.log("issuer", updatedBankSlab.issuer);
                //     console.log("paymentType", updatedBankSlab.paymentType);
                // }

                if (cardType) {
                    updatedBankSlab.cardType = cardType;
                }

                updatedBankSlab.cardType =
                    updatedBankSlab.cardType === 'all'
                        ? null
                        : updatedBankSlab.cardType;

                if (section === NETBANKINGSECTION || section === WALLETSECTION) {
                    updatedBankSlab.issuer = updatedBankSlab.cardType;
                    updatedBankSlab.cardType = null;
                }
                updatedBankSlab.slabs = [
                    {
                        lowerSlab: updatedBankSlab.lowerSlab,
                        upperSlab: updatedBankSlab.higherSlab,
                    },
                ];
                updatedBankSlab.domesticFlag = getSelectedPayModePGMID(section).isDomestic ? 1 : 0;
                updatedBankSlab.paymentType = getSelectedPayModePGMID(section).paymentType;
                delete updatedBankSlab.higherSlab;
                delete updatedBankSlab.lowerSlab;
                delete updatedBankSlab.issuerId;
                const updatedField = {
                    feeType:feeType,
                    paymentOption: updatedBankSlab, 
                };
                feeConfigList = [...feeConfigList, updatedField];
            });
        });
    });
    console.log("is edit mode", isEditMode, netBankingOptions, feeConfigList);
    let request;
    if (isEditMode) {
        request = {
            feeConfigList: [
                // ...netBankingOptions,
                ...feeConfigList,
            ],
        };
    } else {
        request = {
                feeConfigList: [
                    // ...netBankingOptions,
                    ...feeConfigList,
                ],
        };
    }
    return request;
};


export const getSelectedPayModePGMID = sectionType => {
    const allPaymentModes = {
        'Domestic-Debit-Card': {
            paymentType: 'DC',
            isSingleSlab: false,
            isDomestic: true,
        },
        'Foreign-Debit-Card': {
            paymentType: 'DC',
            isSingleSlab: false,
            isDomestic: false,
        },
        'Domestic-Credit-Card': {
            paymentType: 'CC',
            isSingleSlab: true,
            isDomestic: true,
        },
        'Foreign-Credit-Card': {
            paymentType: 'CC',
            isSingleSlab: true,
            isDomestic: false,
        },
        'Net-Banking': {
            paymentType: 'NB',
            isSingleSlab: true,
            isDomestic: true,
        },
        // UPI: { paymentType: 'UPI', isSingleSlab: false, isDomestic: true },
        Wallets: {
            paymentType: 'WALLET',
            isSingleSlab: true,
            isDomestic: true,
        },
    };

    return allPaymentModes[sectionType];
};

export const fetchSectionTypePGMID = (paymode, isDomestic) => {
    switch(paymode) {
        case 'DC':
            if (isDomestic)
                return 'Domestic-Debit-Card';
            else
                return 'Foreign-Debit-Card';
        case 'CC':
            if (isDomestic)
                return 'Domestic-Credit-Card';
            else
                return 'Foreign-Credit-Card';
        case 'NB':
            return 'Net-Banking';
        default:
            return 'Wallets';
    }
}

export const schemensMapp = (type) => {
    const allTypes =  {
        "AMEX": "AMEX",
        "DINR": "DINER",
        "MC": "MASTERCARD",
        "RPAY": "RUPAY",
        "VI": "VISA"
    }
    return allTypes[type];
}

function capitalizeFirst(str) {
    if (!str) return ''; // Handle empty strings
    return str[0].toUpperCase() + str.slice(1).toLowerCase();
}

export const getLabelValuePG = (data, updateLabel = false) => {
    return data.map(item => {
        return {
            label: updateLabel? capitalizeFirst(item) : item ,
            value: item
        }
    })
}
